<div class="aca-localprev" [class.aca-localprev--pdf]="kind() === 'pdf'">
  <!-- toolbar: file identity on the left, view controls on the right -->
  <div class="aca-localprev__bar">
    <span class="aca-localprev__doc">
      <mat-icon aria-hidden="true">description</mat-icon>
      <span class="aca-localprev__name" [title]="file?.name">{{ file?.name }}</span>
    </span>

    <div class="aca-localprev__tools" *ngIf="kind() === 'pdf' || kind() === 'image'">
      <ng-container *ngIf="kind() === 'pdf'">
        <button
          mat-icon-button
          type="button"
          [disabled]="page() <= 1"
          (click)="goToPage(page() - 1)"
          [matTooltip]="'DMS.PREVIEW.PREV_PAGE' | translate"
          [attr.aria-label]="'DMS.PREVIEW.PREV_PAGE' | translate"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="aca-localprev__pages">
          <input class="aca-localprev__pagebox" type="number" [value]="page()" [min]="1" [max]="pageCount()" (change)="onPageInput($event)" />
          / {{ pageCount() }}
        </span>
        <button
          mat-icon-button
          type="button"
          [disabled]="page() >= pageCount()"
          (click)="goToPage(page() + 1)"
          [matTooltip]="'DMS.PREVIEW.NEXT_PAGE' | translate"
          [attr.aria-label]="'DMS.PREVIEW.NEXT_PAGE' | translate"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
        <span class="aca-localprev__sep" aria-hidden="true"></span>
      </ng-container>

      <button
        mat-icon-button
        type="button"
        (click)="zoomOut()"
        [disabled]="zoom() <= 25"
        [matTooltip]="'DMS.PREVIEW.ZOOM_OUT' | translate"
        [attr.aria-label]="'DMS.PREVIEW.ZOOM_OUT' | translate"
      >
        <mat-icon>remove</mat-icon>
      </button>
      <button class="aca-localprev__zoompct" type="button" (click)="resetZoom()" [matTooltip]="'DMS.PREVIEW.RESET_ZOOM' | translate">
        {{ fitWidth() ? ('DMS.PREVIEW.FIT' | translate) : zoom() + '%' }}
      </button>
      <button
        mat-icon-button
        type="button"
        (click)="zoomIn()"
        [disabled]="zoom() >= 300"
        [matTooltip]="'DMS.PREVIEW.ZOOM_IN' | translate"
        [attr.aria-label]="'DMS.PREVIEW.ZOOM_IN' | translate"
      >
        <mat-icon>add</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        [class.aca-localprev__fit--on]="fitWidth()"
        (click)="toggleFitWidth()"
        [matTooltip]="'DMS.PREVIEW.FIT_WIDTH' | translate"
        [attr.aria-label]="'DMS.PREVIEW.FIT_WIDTH' | translate"
      >
        <mat-icon>fit_screen</mat-icon>
      </button>
    </div>
  </div>

  <div class="aca-localprev__body">
    <!-- page rail: jump target for multi-page files -->
    <aside class="aca-localprev__rail" *ngIf="kind() === 'pdf' && thumbs().length > 1">
      <button
        type="button"
        class="aca-localprev__thumb"
        *ngFor="let thumb of thumbs(); let i = index"
        [class.aca-localprev__thumb--active]="page() === i + 1"
        (click)="goToPage(i + 1)"
      >
        <img *ngIf="thumb" [src]="thumb" [alt]="'DMS.PREVIEW.THUMB' | translate: { page: i + 1 }" />
        <span class="aca-localprev__thumbnum">{{ i + 1 }}</span>
      </button>
    </aside>

    <!-- pdf.js draws into this box; it stays in the DOM so renders are never racy -->
    <div class="aca-localprev__stage" #stageWrap [hidden]="kind() !== 'pdf'"></div>

    <div class="aca-localprev__scroll" *ngIf="kind() === 'image'">
      <img class="aca-localprev__img" [src]="imageUrl()" [alt]="file?.name" [style.transform]="imageScale()" />
    </div>

    <div class="aca-localprev__empty" *ngIf="kind() === 'empty'">
      <mat-icon aria-hidden="true">find_in_page</mat-icon>
      <p>{{ 'DMS.PREVIEW.PICK_FILE' | translate }}</p>
    </div>

    <div class="aca-localprev__empty" *ngIf="kind() === 'other'">
      <mat-icon aria-hidden="true">draft</mat-icon>
      <p class="aca-localprev__othername">{{ file?.name }}</p>
      <p class="aca-localprev__othermeta">{{ file?.type || '—' }}</p>
      <p class="aca-localprev__otherhint">{{ 'DMS.PREVIEW.NO_PREVIEW' | translate }}</p>
    </div>

    <div class="aca-localprev__empty aca-localprev__empty--error" *ngIf="failed()">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <p>{{ 'DMS.PREVIEW.FAILED' | translate }}</p>
    </div>

    <div class="aca-localprev__busy" *ngIf="loading()">
      <mat-icon aria-hidden="true" class="aca-localprev__spin">progress_activity</mat-icon>
      <p>{{ 'DMS.PREVIEW.OPENING' | translate }}</p>
    </div>
  </div>
</div>
